export default __webpack_public_path__ + "static/media/aiimagegenerator.612125e5.png";